import React, { Component } from 'react';
import {Button, Nav, Navbar, NavDropdown} from "react-bootstrap";


// In case you need dropdown nav later here's a snippet

class CustomNavbar extends Component {


	renderLetItRideButton () {
			if (this.props.letItRide === true) {
				return ( <Button id="letItRide" value={false} onClick={this.props.onClick} variant="primary">Stop the maddness.</Button> )
			} else {
				return ( <Button id="letItRide" value={true}  onClick={this.props.onClick} variant="outline-primary">Let it ride.</Button> )
			}

	}

	render () {
		console.log("Navbar.props", this.props)
		return (
				<Navbar collapseOnSelect expand="lg" bg="dark" variant="dark" sticky="top">
          <Navbar.Brand>Star Trak Chat Bots: A STAR TREK FAN PRODUCTION</Navbar.Brand>
          <Navbar.Toggle aria-controls="responsive-navbar-nav" />
          <Navbar.Collapse id="responsive-navbar-nav">

            <Nav className="ml-auto p-2">
              {this.renderLetItRideButton()}
              <NavDropdown title="Episodes" id="collasible-nav-dropdown" >
                <NavDropdown.Item disabled href="#/view-episodes">View Previous Episodes</NavDropdown.Item>
                <NavDropdown.Item disabled href="#/save-episode">Save Episode</NavDropdown.Item>
              </NavDropdown>
              <NavDropdown title="About" id="collasible-nav-dropdown"  >
                <NavDropdown.Item href="#/about">About</NavDropdown.Item>
                <NavDropdown.Item disabled href="#/credits">Credits</NavDropdown.Item>
                <NavDropdown.Item disabled href="#/credits">Change Log</NavDropdown.Item>
                <NavDropdown.Item disabled href="#/contact">Contact</NavDropdown.Item>
                <NavDropdown.Item disabled href="#/donate">Donate</NavDropdown.Item>
              </NavDropdown>
            </Nav>
          </Navbar.Collapse>
        </Navbar>

		)
	}
}

export default CustomNavbar;